import {RootCategory} from "@/models/category";

export function getRootCategoryFromPath(path: string, rootCategories: RootCategory[]): RootCategory | undefined {
    return rootCategories.find(rootCategory => rootCategory.path === path);
}